import React, { useState } from "react";
import styles from "../../Styles/Playlist/playlist.module.css";

const Languages = ({ languages, handleFilters, filters }) => {
  const [checked, setChecked] = useState([]);

  const handleToggle = (c) => () => {
    c = c.toLowerCase();
    const currentLanguage = checked.indexOf(c);
    const newCheckedLanguage = [...checked];

    if (currentLanguage === -1) {
      newCheckedLanguage.push(c);
    } else {
      newCheckedLanguage.splice(currentLanguage, 1);
    }

    setChecked(newCheckedLanguage);
    handleFilters(newCheckedLanguage);
  };

  return (
    <>
      <ul>
        {languages.map((creator, index) => {
          return (
            <div key={index}>
              <li key={index} className={styles.list}>
                <input
                  type="checkbox"
                  onChange={handleToggle(creator)}
                  value={checked.indexOf(creator === -1)}
                  checked={
                    filters
                      ? filters.language.includes(creator.toLowerCase())
                      : false
                  }
                />
                {creator}
              </li>
            </div>
          );
        })}
      </ul>
    </>
  );
};

export default Languages;
